import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../../../../services/index";

export const useFetchLineChannels = (companyId) => {
  return useQuery(
    ["lineChannels", companyId],
    async () => {
      const { result } = await GET(`/api/v1/lineChannel`);
      return result || [];
    },
    { enabled: !!companyId }
  );
};

export const useCreateLineChannel = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/lineChannel`, payload),
  });
};

export const useUpdateLineChannel = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) => await PUT(`/api/v1/lineChannel/${id}`, payload),
  });
};

export const useDeleteLineChannel = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/lineChannel/${id}`),
  });
};

// ── ตัวเลือกหมายเหตุที่โผล่บนหน้า LIFF ──
export const useFetchLineRemarks = (companyId) => {
  return useQuery(
    ["lineRemarks", companyId],
    async () => {
      const { result } = await GET(`/api/v1/lineChannel/remarks`);
      return result || [];
    },
    { enabled: !!companyId }
  );
};

export const useCreateLineRemark = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/lineChannel/remarks`, payload),
  });
};

export const useUpdateLineRemark = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) => await PUT(`/api/v1/lineChannel/remarks/${id}`, payload),
  });
};

export const useDeleteLineRemark = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/lineChannel/remarks/${id}`),
  });
};
